import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastNotificationService, Toast } from './toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      <div
        *ngFor="let toast of toasts$ | async; trackBy: trackById"
        class="toast"
        [class.toast--enter]="true"
        (click)="dismiss(toast.id)">
        <div class="toast__icon" [ngClass]="'toast__icon--' + toast.type">
          <span *ngIf="toast.type === 'success'">✓</span>
          <span *ngIf="toast.type === 'error'">✕</span>
          <span *ngIf="toast.type === 'warning'">!</span>
          <span *ngIf="toast.type === 'info'">i</span>
          <div *ngIf="toast.type === 'loading'" class="toast__spinner"></div>
        </div>
        <span class="toast__message">{{ toast.message }}</span>
      </div>
    </div>
  `,
  styles: [`
    .toast-container {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 8px;
      pointer-events: none;
    }

    .toast {
      background: #18181b;
      color: #fff;
      padding: 12px 18px;
      border-radius: 100px;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      pointer-events: auto;
      animation: slideUp 0.3s ease-out;
    }

    .toast__icon {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-weight: bold;
      flex-shrink: 0;
    }

    .toast__icon--success {
      background: #22c55e;
      color: #fff;
    }

    .toast__icon--error {
      background: #ef4444;
      color: #fff;
    }

    .toast__icon--warning {
      background: #f59e0b;
      color: #fff;
    }

    .toast__icon--info {
      background: #717171;
      color: #fff;
    }

    .toast__icon--loading {
      background: transparent;
    }

    .toast__spinner {
      width: 16px;
      height: 16px;
      border: 2px solid #444;
      border-top-color: #fff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    .toast__message {
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(16px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `]
})
export class ToastContainerComponent {
  toasts$ = this._toastService.toasts$;

  constructor(private _toastService: ToastNotificationService) {}

  trackById(index: number, toast: Toast): string {
    return toast.id;
  }

  dismiss(id: string): void {
    this._toastService.dismiss(id);
  }
}
